const Logger = {
  info: console.info,
  error: console.error,
  warn: console.warn,
  debug: console.debug,
  fatal: console.error,
};

export { Logger };
